/*
 * @Author: edvardchen
 * @Date:   2016-10-20 15:56:58
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:30:11
 */
import PropTypes from 'prop-types';
import _ from 'lodash';
import React from 'react';
// import autobind from 'core-decorators/lib/autobind';
import shallowEqual from 'fbjs/lib/shallowEqual';

import { isAndroid, isQQBrowser, withinShare } from '../utility';

const getUserAgent = (routeParams) => {
  if (__CLIENT__) {
    return window.navigator.userAgent;
  }
  return routeParams.userAgent;
};

const contextTypes = {
  location: PropTypes.object,
  isQQBrowser: PropTypes.bool,
  isAndroid: PropTypes.bool,
  share: PropTypes.bool,
  currentChannel: PropTypes.string, // 当前渠道号
};

export { contextTypes };

export default function withRoute(Component) {
  class Proxy extends React.Component {
    static displayName = `${Component.displayName || Component.name}RouteProxy`;

    static childContextTypes = contextTypes;

    getChildContext() {
      const { location } = this.props;
      const userAgent = getUserAgent(this.props.params);

      // 和后台页面缓存使用的 key 保持一致
      // 所以不直接 expose userAgent
      // 而是提供页面缓存使用的 key 包含的信息
      return {
        location,
        currentChannel: location.query.ch,
        isQQBrowser: isQQBrowser(userAgent),
        isAndroid: isAndroid(userAgent),
        share: withinShare({ userAgent, query: location.query }),
      };
    }

    shouldComponentUpdate(nextProps) {
      // ignore hash change
      const keys = ['location.pathname', 'location.query'];
      const same = keys.every((k) => shallowEqual(_.get(this.props, k), _.get(nextProps, k)));
      // return !shallowEqual(this.props, nextProps);
      return !same;
    }

    render() {
      const { location, params } = this.props;
      const { query } = location;
      return <Component variables={{ ...query, ...params }} />;
    }
  }

  Proxy.propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object.isRequired,
    }).isRequired,
    params: PropTypes.object.isRequired,
  };

  return Proxy;
}
